// extracted by mini-css-extract-plugin
export default {"loadingMethod":"DefaultPayoutMethod_loadingMethod__M6IE+"};